var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWarranty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 454.9 455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.2,286.9L156,230.6l21.5-21.5l34.7,34.8l65.1-65.1l21.5,21.5L212.2,286.9z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.4,455c-3.6,0-7.1-1.2-9.8-3.6l-61.3-52.3l-80.1-6.5c-7.6-0.5-13.7-6.6-14.2-14.2l-6.3-79.8L3.6,237.3 c-4.8-5.7-4.8-14,0-19.6l52.2-61.3l6.5-80.1c0.5-7.6,6.6-13.7,14.2-14.2l79.8-6.3l61.3-52.2c5.7-4.8,14-4.8,19.6,0l61.3,52.2 l80.1,6.5c7.6,0.5,13.7,6.6,14.2,14.2l6.3,79.8l52.2,61.3c4.8,5.7,4.8,14,0,19.6l-52.2,61.3l-6.5,80.1c-0.5,7.6-6.6,13.7-14.2,14.2 l-79.8,6.3l-61.3,52.2C234.5,453.7,231.1,455,227.4,455z M91.5,363.4l72.1,5.8c3.2,0.2,6.2,1.5,8.7,3.6l55.2,47.1l55.2-47.1 c2.4-2.1,5.5-3.3,8.7-3.6l72.1-5.8l6.3-72.1c0.2-3.2,1.5-6.2,3.6-8.7l46.6-55.2l-47.1-55.2c-2.1-2.4-3.3-5.5-3.6-8.7l-5.8-72.1 l-72.1-6.3c-3.2-0.2-6.2-1.5-8.7-3.6L227.4,35l-55.2,47.1c-2.4,2.1-5.5,3.3-8.7,3.6l-72.1,5.8l-6.3,72.1c-0.2,3.2-1.5,6.2-3.6,8.7 L35,227.4l47.1,55.2c2.1,2.4,3.3,5.5,3.6,8.7L91.5,363.4z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarranty);
export default __webpack_public_path__ + "static/media/icon-warranty.c4c83ab0901c8f67a843f95e6fde2b9d.svg";
export { ForwardRef as ReactComponent };